module.exports = __webpack_public_path__ + "img/add_img.c7ab0ff1.png";